import http from "../common/http-common";
import {
  DTOCatalogosRespaldos,
  DTOEquipoConRespaldos,
  DTOGestionarRespaldo,
  DTOGuardarBitacoraRespaldo,
  DTOReporteMensualRespaldos,
  DTORespaldoInventario,
  DTOResultadoRespaldo,
} from "../../DTO/Inventario/DTORespaldos";

class RespaldosService {
  obtenerCatalogos() {
    return http.get<DTOCatalogosRespaldos>("/respaldos/catalogos");
  }

  obtenerEquipos(soloActivos = true) {
    return http.get<DTOEquipoConRespaldos[]>("/respaldos/equipos", {
      params: { soloActivos },
    });
  }

  obtenerPorEquipo(idEquipo: number, incluirInactivos = false) {
    return http.get<DTORespaldoInventario[]>(
      `/respaldos/equipos/${idEquipo}/configuraciones`,
      { params: { incluirInactivos } }
    );
  }

  gestionar(dto: DTOGestionarRespaldo) {
    return http.post<DTOResultadoRespaldo>(
      "/respaldos/configuraciones/gestionar",
      dto
    );
  }

  guardarBitacora(dto: DTOGuardarBitacoraRespaldo) {
    return http.post<DTOResultadoRespaldo>(
      "/respaldos/bitacora/guardar",
      dto
    );
  }

  obtenerReporteMensual(idEquipo: number, anio: number, mes: number) {
    return http.get<DTOReporteMensualRespaldos>(
      "/respaldos/bitacora/mensual",
      { params: { idEquipo, anio, mes } }
    );
  }
}

const respaldosService = new RespaldosService();

export default respaldosService;
